import { useState } from "react";
import "./Signup.css";
import logo from "./assets/logoWithText.avif";
import { useNavigate } from "react-router-dom";

export default function Signup() {
  const [firstName, setFirstName] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [language, setLanguage] = useState("");
  const [referral, setReferral] = useState("");

  const navigate = useNavigate();

  const handleSignup = async () => {
    const res = await fetch(
      "https://web.theplatformapi.com/create-company-user?companyName=TREDIXO&isDemo=false&parentId=6",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          firstName,
          mobile,
          password,
          confirmPassword,
          language,
          referral,
        }),
      }
    );

    const data = await res.json();
    console.log(data);
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <img src={logo} alt="TrediXO" />
        </div>

        <div className="auth-title">Create A Live Account</div>
        <div className="auth-subtitle">Personal Details</div>

        {/* First row */}
        <div className="auth-row">
          <input
            className="auth-input"
            placeholder="Firstname"
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />


          <input
            className="auth-input"
            placeholder="Enter Mobile number"
            value={mobile}
            onChange={(e) => setMobile(e.target.value)}
          />

        </div>

        {/* Second row */}
        <div className="auth-row">
          <input
            className="auth-input"
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <input
            className="auth-input"
            type="password"
            placeholder="Confirm Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
        </div>

        <select
          className="auth-input"
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
        >
          <option value="">RM Support Language</option>
          <option value="english">English</option>
          <option value="hindi">Hindi</option>
        </select>

        <input
          className="auth-input"
          placeholder="Referral Code (if you have one)"
          value={referral}
          onChange={(e) => setReferral(e.target.value)}
        />

        <button className="auth-btn" onClick={handleSignup}>
          Create Account
        </button>
        <div className="auth-footer">
          Already have an account?<span
            onClick={() => navigate("/login")}
            style={{ color: "blue", cursor: "pointer" }}
          >
            Log in
          </span>
        </div>
      </div>
    </div>
  );
}
